export const formatPercent = (value, options)=>{
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    return `${((isNaN(numericValue) ? 0 : numericValue) * 100).toFixed(options?.fractionDigits ?? 0)}%`;
};

//# sourceMappingURL=formatPercent.js.map